import { render, staticRenderFns } from "./itemsComponent.vue?vue&type=template&id=fe6c612e&scoped=true&"
import script from "./itemsComponent.vue?vue&type=script&lang=js&"
export * from "./itemsComponent.vue?vue&type=script&lang=js&"
import style0 from "./itemsComponent.vue?vue&type=style&index=0&id=fe6c612e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6c612e",
  null
  
)

export default component.exports